import { useMemberGetQuery, useMemberMutate } from "modules/members/api";
import { AppField } from "state/customFields";
import { MemberAccount } from "state/member";
import { MFMember } from "./member";
import type { AppTenantFields } from "modules/apps/tenants";

export interface MFApp extends AppTenantFields {
  id: string;
  domain: string;
  name: string;
  category: string;
  owner?: MFMember;
  ployFields?: {
    owningDepartment?: string;
  };
  appFieldValues?: {
    id: string;
    valueMember?: MFMember;
    value: any;
    type: AppField["type"];
    fieldLabel: string;
  }[];
  links: {
    logoUrl: string;
  };
}

export interface MFMemberApp {
  id: string;
  app: MFApp;
  authType: MemberAccount["authType"];
  firstSeen?: string;
  authAccountDomain?: string;
  requiredStatus: "member_required" | "member_not_required";
  lastDetectedSignIn: string;
}

const useListApps = (): MFMemberApp[] => {
  const data = useMemberGetQuery<MFMemberApp[]>(
    ["mf", "apps"],
    "/members/apps",
  );
  return data.data || [];
};

const useChangeRequiredStatus = () => {
  const { mutate, isLoading } = useMemberMutate(
    "POST",
    "/members/apps/change-required-status",
    [["mf", "apps"]],
  );
  return {
    isLoading,
    mutate: ({
      status,
      appId,
    }: {
      status: MFMemberApp["requiredStatus"];
      appId: string;
    }) => {
      mutate({ status, app_id: appId });
    },
  };
};

export const MF_APPS = {
  useListApps,
  useChangeRequiredStatus,
};
